import create from 'zustand'
import { persist } from 'zustand/middleware'
//@ts-ignore
const [mainSearchStore] = create(persist(set => ({
  mainInfo: { selectIndex : "", searchQuery : ""},
  setMainInfo: (selectIndexData, searchQueryData) => {
    set({ mainInfo: {selectIndex : selectIndexData, searchQuery: searchQueryData}});
  },
  setMkInfo: (selectIndexData, searchQueryData, title, description) => set(state => ({
    mainInfo: {
      selectIndex: selectIndexData,
      searchQuery: searchQueryData,
      title: title,
      description: description
    }
  })),
  clearMainInfo : () => set({mainInfo : { selectIndex : "", searchQuery : "", title: "", description: "" }
  }),
})))

export default mainSearchStore;